import { z } from 'zod'

export const env = z
  .object({
    REACT_APP_API_URL: z.string(),
    REACT_APP_BACKEND_API_URL: z.string(),
    NODE_ENV: z.enum(['development', 'production', 'test']),
  })
  .parse(process.env)
